import React from 'react'
import ImagesUroliftGallery from "./ImagesUroliftGallery"
import {Link} from "@material-ui/core"

const HIFEM_EN = () => {
    return (
        <section id="about1">
            <div className="row">


<h2>HIFEM treatment in our urological practice</h2>

<p>HIFEM, a painless and non-invasive therapy, utilizes electromagnetic fields to stimulate pelvic floor muscles in both women and men. HIFEM therapy is designed to enhance the strength of pelvic floor muscles, aiming to address various medical conditions associated with these muscles, ranging from urinary incontinence to erectile dysfunction.</p>

<h2>Medical Conditions Treated by HIFEM</h2>

<p>Urinary incontinence: HIFEM can bolster pelvic floor muscle strength to effectively treat urinary incontinence.
Post prostatectomy: Following prostatectomy surgery in patients with prostate cancer, urinary incontinence is prevalent. HIFEM therapy can be employed to assist in such cases.
Erectile Dysfunction: Erectile dysfunction, ejaculation, and orgasm are intricately linked to pelvic floor dysfunction. HIFEM can enhance pelvic floor muscle activity, improving muscle contraction non-invasively.</p>

<h2>How HIFEM Works</h2>

<p>HIFEM therapy employs a specialized device emitting an electromagnetic field specifically targeted to pelvic floor muscles while the patient is seated. This stimulates thousands of pelvic floor muscle contractions during a single therapy session, offering a more effective and efficient approach compared to conventional exercises like Kegel exercises alone.</p>

<h2>Can I Get HIFEM Therapy?</h2>

<p>HIFEM is a safe and effective therapy for both men and women seeking to increase pelvic floor muscle strength. However, to determine its appropriateness for your current medical condition, consulting a doctor, especially a urologist, is crucial. Your doctor will evaluate your condition to determine whether this therapy is the right approach for your medical needs.</p>

<h2>HIFEM Therapy Procedure</h2>

<p>HIFEM therapy involves sitting on a specialized HIFEM chair. Electromagnetic waves from the chair stimulate your pelvic floor muscles, allowing you to feel the contractions during the procedure. This non-invasive and painless process enables you to resume your normal activities immediately after therapy.</p>

<h2>HIFEM Therapy Duration</h2>

<p>A single HIFEM therapy session lasts approximately 28 minutes. Most individuals typically require about six sessions, following a doctor's schedule.</p>

<h2>How Long Does It Take To See Results?</h2>

<p>While the timeline for experiencing results varies from person to person, generally, the impact of HIFEM therapy can be felt after the first session, with increasing effectiveness in the weeks following subsequent sessions.</p>

 
            </div>
        </section>
    )
}

export default HIFEM_EN



// WEBPACK FOOTER //
// ./src/Components/HIFEM/HIFEM_EN.js